"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classNames = void 0;
var classNames = exports.classNames = function classNames() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return params.reduce(function (previous, current) {
    if (typeof current === 'boolean' || Boolean(current) === false && typeof current !== 'number' || current === undefined || current === null || current === '') return previous;
    return previous.concat(current);
  }, []).join(' ');
};